<div class="public-stream-container">
  <header class="stream-header">
    <img src="/assets/images/logo/logo.svg" alt="Logo" class="header-logo">
  </header>
  
  <div class="stream-wrapper">
    <!-- Error Message -->
    <div class="error-message" *ngIf="error">
      <p>{{ error }}</p>
    </div>

    <!-- Stream Content - Show immediately, don't wait for loading -->
    <div class="stream-content" *ngIf="!error && cameras.length > 0">
      <div class="camera-stream" *ngFor="let camera of cameras; let i = index; trackBy: trackByIndex">
        <div class="camera-label">
          <h2>Camera {{ i + 1 }}</h2>
          <span class="camera-status" *ngIf="camera.isLoading">
            <span class="status-indicator loading"></span>
            Loading...
          </span>
          <span class="camera-status" *ngIf="camera.hasError && !camera.isLoading">
            <span class="status-indicator error"></span>
            Connection issue
          </span>
          <span class="camera-status" *ngIf="camera.isLoaded && !camera.isLoading">
            <span class="status-indicator loaded"></span>
            Live
          </span>
        </div>
        <div class="iframe-wrapper">
          <!-- Loading overlay for individual camera -->
          <div class="camera-loading-overlay" *ngIf="camera.isLoading">
            <div class="loader-spinner"></div>
            <p class="loading-text">Loading stream...</p>
          </div>
          <!-- Error overlay for individual camera -->
          <div class="camera-error-overlay" *ngIf="camera.hasError && !camera.isLoading">
            <p class="error-text">Unable to load camera stream</p>
            <p class="error-subtext">Please check your connection</p>
          </div>
          <iframe 
            allow="fullscreen" 
            height="100%" 
            width="100%" 
            [src]="camera.url"
            class="stream-iframe"
            [class.loaded]="camera.isLoaded">
          </iframe>
        </div>
      </div>
    </div>
  </div>
</div>

